var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper",staticStyle:{"height":"100vh"}},[_c('app-input',{attrs:{"type":"text-editor","name":"text-editor","id":"text-editor","placeholder":_vm.placeholder,"initialValue":_vm.value,"field-props":_vm.fieldStatus}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }